/**
 * Calculate Delay for things, for example for debouncing tracking
 */
export class DelayTimeCalculator {
  private startTime = 0;
  private timesCalled = 0;
  private totalTime = 0;
  private minDelay;
  private maxDelay;

  constructor(minDelay: number, maxDelay: number) {
    this.minDelay = minDelay;
    this.maxDelay = maxDelay;
  }

  /**
   * Updates the calculator, and starts it before if necessary
   */
  update() {
    if (this.startTime === 0) {
      this.startTime = Date.now();
    }
    this.timesCalled += 1;
    this.totalTime = Date.now() - this.startTime;
  }

  /**
   * resets the calculator
   */
  reset() {
    this.startTime = 0;
    this.totalTime = 0;
    this.timesCalled = 0;
  }

  /**
   * calculates a delay twice the average time per times called, and returns a value between the min and max delay
   */
  getDelayTime(): number {
    const calculatedDelay = (2 * this.totalTime) / this.timesCalled;

    if (calculatedDelay >= this.maxDelay) {
      return this.maxDelay;
    }

    if (calculatedDelay <= this.minDelay) {
      return this.minDelay;
    }

    return calculatedDelay;
  }
}
